
export default {
  name: 'VsRatio',
  inheritAttrs: false,
  props: {
    ratio: {
      type: [String, Boolean, Object],
      default: '16/9'
    },
    items: {
      type: [String, Object],
      default: 'center'
    },
    justify: {
      type: [String, Object],
      default: 'center'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    ratio: {
      position: 'relative',
      $ratio: 'aspectRatio'
    },
    slot: {
      position: 'absolute',
      pin: true,
      width: 'full',
      height: 'full'
    }
  }
}
